import React from 'react';

import { Svg, type SvgProps } from './svg';

export function MessageIcon(props: SvgProps) {
  return (
    <Svg data-testid="message-icon" {...props}>
      <path d="M20 2H4C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4V22L6 18H20C20.5304 18 21.0391 17.7893 21.4142 17.4142C21.7893 17.0391 22 16.5304 22 16V4C22 2.89 21.1 2 20 2Z" />
    </Svg>
  );
}
